import { Link } from 'react-router-dom';
import { movieCategories, movies } from '@/mocks/movies';

export default function CategorySection() {
  const getCategoryCount = (slug: string) => {
    return movies.filter((m) => m.categorySlug === slug).length;
  };

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-[var(--font-heading)]">
            影片分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型浏览您感兴趣的影片</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {movieCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-4 md:p-5 flex flex-col items-center text-center cursor-pointer hover:bg-accent-50 transition-colors duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-accent-100 rounded-xl mb-3 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">{cat.name}</h3>
              <span className="text-xs text-foreground-400">{getCategoryCount(cat.slug)} 部影片</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}